module.exports = ".row:nth-child(odd){\r\n    background: #f3f3f3;\r\n }"


//////////////////
// WEBPACK FOOTER
// ./src/app/fund-management/fund-management.component.css
// module id = ./src/app/fund-management/fund-management.component.css
// module chunks = main